import { Buyer, BuyerFilter, BlacklistActionRequest } from '../models/Buyer';
import { post } from '../utils/backend';
import { getMockData, mock } from './mock/Mock';
import './mock/BuyerMock';

const getBuyerList = async (filter: BuyerFilter): Promise<Buyer[]> => {
    if (mock) {
        return getMockData("getBuyerList");
    }
    const resultOrErrorCode = await post<BuyerFilter, Buyer[]>('/api/buyer/list', filter);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return [];
    }
    return resultOrErrorCode;
};

const blacklistBuyer = async (request: BlacklistActionRequest): Promise<boolean> => {
    if (mock) {
        return true;
    }
    const resultOrErrorCode = await post<BlacklistActionRequest, void>('/api/buyer/blacklist', request);
    if (typeof resultOrErrorCode === 'string') {
        // 错误码处理
        return false;
    }
    return true;
};

export const BuyerApi = {
    getBuyerList,
    blacklistBuyer
};